import { useState } from 'react';
import './App.css';

const App_projects = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [downloadLink, setDownloadLink] = useState("");

  const links = [
    {
      url: "ChatCraft.apk", 
      imgSrc: "chat.jpeg",
      text: "Public Chat Application",
    },
    {
      url: "basic_1.apk", 
      imgSrc: "basic_11.jpeg",
      text: "Basic Project 1",
    },
    {
      url: "basic_2.apk", 
      imgSrc: "basic_22.jpeg",
      text: "Basic Project 2",
    },
  ];

  const handleLinkClick = (url) => {
    setDownloadLink(url);
    setShowPopup(true);
  };

  const handleDownload = () => {
    window.location.href = downloadLink;
    setShowPopup(false); 
  };

  const handleCancel = () => {
    setShowPopup(false);
  };

  return (
    <>
      <div id="dynamicLinks">
      <p style={{margin: "0px", marginBottom: "10px", fontWeight: "500", fontFamily: "cursive"}}>Android Projects</p>
        {links.map((link, index) => (
          <div key={index} onClick={() => handleLinkClick(link.url)}>
            <div className="main-child">
              <div className="img-view">
                <img src={link.imgSrc} alt={link.text} />
              </div>
              <div className="text">
                <p>{link.text}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {showPopup && <div className="overlay"></div>}

      {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <p>Are you sure you want to download the APK file?</p>
            <button onClick={handleDownload}>Okay</button>
            <button onClick={handleCancel}>Cancel</button>
          </div>
        </div>
      )}
    </>
  );
};

export default App_projects;
